{
  "title": "Mag-ulat ng emergency",
  "callFirstTitle": "Tumawag sa 911",
  "callFirstBody": "Ang pagtawag ang pinakamabilis na paraan para makakuha ng tulong. Ang form na ito ay pangalawang paraan na nagpapadala ng iyong detalye sa mga dispatcher ng LGU.",
  "formTitle": "Magpadala ng ulat",
  "formLead": "Mga 30 segundo lang. Kailangan lang kung ano ang nangyayari, saan, at paano ka makokontak.",
  "whatHappening": "Ano ang nangyayari?",
  "chooseType": "Piliin kung ano ang nangyayari",
  "type_fire": "Sunog",
  "type_flood": "Baha",
  "type_landslide": "Pagguho ng lupa",
  "type_medical": "Medikal",
  "type_road_accident": "Aksidente sa daan",
  "type_trapped_persons": "May na-trap",
  "type_crime": "Krimen",
  "type_other": "Iba pa",
  "where": "Saan ito?",
  "mapLabel": "Mapa ng mga ulat ng emergency",
  "barangayRequired": "Piliin ang barangay (kailangan dahil hindi naibahagi ang iyong lokasyon)",
  "landmarkHint": "Nakakatulong ang malapit na palatandaan para mahanap ng mga responder ang lugar.",
  "landmarkPlaceholder": "hal. tabi ng kapilya, malapit sa gate ng paaralan",
  "peopleAffected": "Ilan ang apektado?",
  "injured": "May nasugatan ba?",
  "description": "Ano ang dapat malaman ng mga responder?",
  "descriptionHint": "Opsyonal. Paikliin lang.",
  "you": "Iyong contact details",
  "yourName": "Iyong pangalan",
  "yourMobile": "Numero ng mobile",
  "mobileHint": "Maaaring tawagan ka ng mga responder.",
  "noAccountNeeded": "Hindi kailangan ng account. Awtomatikong napupunan ang detalye ng mga naka-sign in.",
  "send": "Ipadala ang ulat",
  "sending": "Ipinapadala…",
  "queuedTitle": "Na-save — ipapadala kapag may koneksyon na",
  "queuedBody": "Naka-save ang iyong ulat sa teleponong ito at awtomatikong ipapadala kapag may signal na. Kung kaya, tumawag sa 911 ngayon.",
  "pendingTitle": "Naghihintay maipadala ({count})",
  "pendingItem": "{title} · na-save {time}",
  "failedSend": "Hindi naipadala: {message}",
  "discard": "Itapon",
  "sendAnother": "Magpadala ng isa pang ulat",
  "tryAgainNow": "Subukang ipadala ngayon",
  "checkForm": "Pakisuri ang mga naka-highlight na field.",
  "trackTitle": "Ulat {ref}",
  "trackLead": "Nag-a-update ang pahinang ito habang tumutugon ang mga dispatcher. Itago ang link para tingnan ulit.",
  "status_received": "Natanggap",
  "status_acknowledged": "Kinilala",
  "status_dispatched": "Naipadala ang mga responder",
  "status_on_scene": "Nasa lugar na",
  "status_resolved": "Nalutas",
  "status_closed": "Sarado",
  "closedNote": "Sarado na ang ulat na ito. Kung kailangan mo pa ng tulong, tumawag sa 911 o magpadala ng bagong ulat.",
  "respondersAssigned": "May mga responder nang naitalaga.",
  "reportedAt": "Iniulat {time}",
  "offlineSnapshot": "Offline ka. Ito ang huling naka-save na katayuan.",
  "timeline": "Mga update",
  "author_reporter": "Ikaw",
  "author_staff": "Dispatcher",
  "author_system": "Sistema",
  "addInfo": "Magdagdag ng impormasyon",
  "addInfoHint": "Sabihin sa mga responder ang anumang bago, halimbawa kung nagbago ang sitwasyon.",
  "addInfoSend": "Ipadala ang update",
  "addInfoSent": "Naipadala ang update",
  "notFound": "Hindi mabuksan ang ulat na ito. Gamitin ang link na ipinakita pagkatapos mong ipadala ito, sa parehong telepono.",
  "copyLink": "Kopyahin ang link ng ulat na ito",
  "noUpdatesYet": "Wala pang update. Natanggap na ng mga dispatcher ang iyong ulat.",
  "myTitle": "Aking mga ulat ng emergency",
  "myEmpty": "Walang ulat ng emergency mula sa iyo o sa device na ito.",
  "waitingToSend": "Naghihintay maipadala",
  "dispatchTitle": "Dispatch",
  "unackCount": "{count} hindi pa kinikilala",
  "enableSound": "I-on ang tunog ng alerto",
  "soundOn": "Naka-on ang tunog ng alerto",
  "smsNotConfigured": "HINDI naka-configure ang SMS. Hindi makakatanggap ng text ang mga responder — naitatala lang ang mga bagong ulat at pagtatalaga. Tawagan nang direkta ang mga team at hilingin sa administrator na i-set ang SEMAPHORE_API_KEY.",
  "smsNoTeams": "Walang responder team na nakatakdang makatanggap ng SMS sa bawat bagong ulat. Maaari itong i-on ng administrator sa Mga responder team.",
  "viewActive": "Aktibo",
  "viewClosed": "Sarado",
  "viewAll": "Lahat",
  "search": "Maghanap ng ulat",
  "searchPlaceholder": "Ref, pangalan, mobile o palatandaan",
  "queueEmpty": "Walang aktibong ulat. Agad lalabas dito ang mga bagong ulat.",
  "notAcknowledged": "Hindi pa kinikilala",
  "escalated": "Naghihintay nang mahigit 2 minuto",
  "selectReport": "Pumili ng ulat para makita ang detalye.",
  "reported": "Iniulat",
  "queuedOnDevice": "Na-save sa telepono ng nag-ulat noong {time} (naipadala mamaya)",
  "reporter": "Nag-ulat",
  "callReporter": "Tawagan ang {mobile}",
  "hasAccount": "Residenteng naka-sign in",
  "location": "Lokasyon",
  "noLocation": "Walang naibahaging GPS na lokasyon",
  "openInMaps": "Buksan sa Google Maps",
  "accuracy": "±{m} m",
  "people": "Mga apektado",
  "injuries": "Mga nasugatan",
  "priorFlagged": "{count} naunang ulat mula sa numerong ito ang na-flag bilang biro o spam.",
  "photos": "Mga larawan",
  "timelineAll": "Timeline",
  "internal": "Panloob",
  "seenByReporter": "Nakikita ng nag-ulat",
  "actions": "Mga aksyon",
  "acknowledge": "Kilalanin",
  "priority": "Prayoridad",
  "priority_low": "Mababa",
  "priority_normal": "Karaniwan",
  "priority_high": "Mataas",
  "priority_critical": "Kritikal",
  "setPriority": "Itakda ang prayoridad",
  "assignTeam": "Magtalaga ng responder",
  "team": "Team",
  "chooseTeam": "Pumili ng team",
  "noTeamsYet": "Wala pang responder team. Idinadagdag ito ng administrator sa Mga responder team.",
  "noteForTeam": "Tala para sa team (ipapadala sa SMS)",
  "assign": "Italaga at magpadala ng SMS",
  "assignedTo": "Naitalaga sa {team}",
  "notAssigned": "Hindi pa naitatalaga",
  "smsSent": "Naipadala ang SMS sa {count} responder",
  "smsNotSent": "Hindi naka-configure ang SMS — tawagan ang team.",
  "updateStatus": "I-update ang katayuan",
  "newStatus": "Bagong katayuan",
  "note": "Tala",
  "showToReporter": "Ipakita ang talang ito sa nag-ulat",
  "saveUpdate": "I-save ang update",
  "internalNote": "Panloob na tala",
  "addNote": "Idagdag ang tala",
  "markDuplicate": "Markahan bilang doble",
  "duplicateOf": "Reference ng orihinal na ulat",
  "duplicateBtn": "Markahang doble at isara",
  "duplicateOfLabel": "Doble ng {ref}",
  "flagReport": "I-flag ang ulat",
  "flag_prank": "Biro",
  "flag_spam": "Spam",
  "notFlagged": "Hindi naka-flag",
  "flagNote": "Dahilan",
  "saveFlag": "I-save ang flag",
  "flaggedAs": "Naka-flag: {flag}",
  "disasterEvent": "Sakuna",
  "acknowledgedBy": "Kinilala ni {name}",
  "showList": "Bumalik sa pila",
  "saved": "Na-save",
  "newReportToast": "Bagong ulat ng emergency {ref}",
  "waitingFor": "naghihintay {time}",
  "respondersTitle": "Mga responder team",
  "respondersLead": "Mga team at numerong tumatanggap ng dispatch SMS. Itinatalaga ng mga dispatcher ang mga team na ito sa mga ulat.",
  "newTeam": "Bagong team",
  "editTeam": "I-edit ang team",
  "teamName": "Pangalan ng team",
  "teamDescription": "Paglalarawan",
  "notifyOnNew": "I-text ang team na ito sa bawat bagong ulat",
  "active": "Aktibo",
  "inactive": "Hindi aktibo",
  "contacts": "Mga contact",
  "addContact": "Magdagdag ng contact",
  "contactName": "Pangalan",
  "contactMobile": "Numero ng mobile",
  "contactActive": "Tumatanggap ng SMS",
  "saveTeam": "I-save ang team",
  "deleteTeam": "Burahin ang team",
  "deleteConfirm": "Burahin ang team na ito? Hindi mabubura ang mga team na naitalaga na sa mga ulat; i-off na lang ang mga ito.",
  "noTeams": "Wala pang responder team. Idagdag ang mga team na tumutugon sa emergency para maitalaga sila ng mga dispatcher.",
  "getsNew": "Tumatanggap ng bawat bagong ulat",
  "contactCount": "{count} contact",
  "liveUpdates": "Live na update",
  "gpsOnly": "May naibahaging GPS pin",
  "responderTitle": "Responder · {type}",
  "responderLead": "Naitalaga ka sa ulat na ito. Ibahagi ang iyong lokasyon para makita ng dispatcher at ng nag-ulat na papunta ka na.",
  "responderPrivacy": "Ibinabahagi lang ang iyong lokasyon para sa ulat na ito, habang naka-on ang pagbabahagi, at sa mga dispatcher at sa nag-ulat lamang.",
  "startSharing": "Simulan ang pagbabahagi ng lokasyon",
  "stopSharing": "Itigil ang pagbabahagi",
  "sharingOn": "Ibinabahagi ang lokasyon mo · huling naipadala {ago} ang nakalipas",
  "sharingStarting": "Hinahanap ang lokasyon mo…",
  "sharingOff": "Naka-off ang pagbabahagi ng lokasyon.",
  "keepOpen": "Panatilihing bukas ang pahinang ito habang bumibiyahe.",
  "arrived": "Nakarating na kami",
  "arrivedDone": "Naitala na nasa lugar na kayo. Salamat.",
  "reportEnded": "Naresolba o sarado na ang ulat na ito. Itinigil na ang pagbabahagi ng lokasyon.",
  "linkInvalid": "Hindi na gumagana ang responder link na ito. Humingi ng bago sa dispatcher.",
  "locationDenied": "Naka-block ang lokasyon para sa site na ito. Payagan ang lokasyon sa settings ng browser, saka subukan ulit.",
  "locationUnavailable": "Hindi makita ang lokasyon mo. Lumipat sa bukas na lugar at subukan ulit.",
  "directions": "Direksyon",
  "incident": "Insidente",
  "responderMapLabel": "Mapa ng insidente at ng responder team",
  "onTheWay": "Paparating na ang tulong",
  "teamAway": "Ang {team} ay {distance} ang layo (tuwid na sukat) · na-update {ago} ang nakalipas",
  "responderLabel": "Responder",
  "responderAway": "{distance} ang layo (tuwid na sukat) · na-update {ago} ang nakalipas",
  "responderWaiting": "Hinihintay na ibahagi ng team ang lokasyon nito.",
  "responderStale": "Huling ibinahagi {ago} ang nakalipas",
  "copyResponderLink": "Kopyahin ang responder link",
  "responderLinkHint": "Naipadala sa team sa SMS. Kopyahin kung kailangan ulit ng responder.",
  "responderMarker": "Responder team",
  "callSending": "Ipinapadala ang lokasyon mo…",
  "callNotice": "Kapag tumawag ka mula rito, ipinapadala rin ang lokasyon mo sa mga dispatcher ng LGU bilang hiling ng tulong, para mahanap ka nila kahit maputol ang tawag.",
  "callTitle": "Tawag sa {name}",
  "callRequest": "Hiling ng tulong mula sa tawag",
  "calledVia": "Tumawag sa {name} mula sa app",
  "calledViaShort": "Tumawag sa {name}",
  "noMobileGiven": "Walang numerong ibinigay (hindi naka-sign in)",
  "hqTitleTown": "Headquarters",
  "hqTitleBarangay": "Headquarters ng {name}",
  "hqLive": "Live",
  "hqActive": "Aktibong ulat",
  "hqUnack": "Hindi pa natatanggap",
  "hqOnTheWay": "Team na papunta",
  "hqOnScene": "Nasa lugar na",
  "hqResolvedToday": "Naresolba ngayon, sa {total} na naiulat",
  "hqCallsToday": "Tawag mula sa app ngayon",
  "hqEvacuees": "Evacuees · {open} bukas na site · kasya pa ang {capacity}",
  "hqFeed": "Mga live na ulat",
  "hqNoReports": "Walang aktibong ulat. Ligtas ang lahat.",
  "hqSites": "Mga evacuation site",
  "hqNoSites": "Wala pang evacuation site sa lugar na ito.",
  "hqTeams": "Mga responder team",
  "hqTeamFree": "Handa",
  "hqTeamOn": "Nasa {ref}",
  "hqFullscreen": "Full screen",
  "hqExitFullscreen": "Lumabas sa full screen",
  "hqReadOnly": "Pagtingin lamang. Ang MDRRMO ang humahawak ng dispatch; mga ulat dito ay nasa barangay ninyo.",
  "hqMapLabel": "Mapa ng mga aktibong ulat, responder team at evacuation site",
  "hqEmergencyOn": "Naka-on ang emergency mode"
}
